import { useState } from "react";
import Button from "components/button";
import { Card } from "antd";
import { Box } from "@towersystems/towersystems-design-system";
import logo from "assets/images/logo_color.png";
import ButtonGroup from "../button-group";
import page from "page";
import Preloader from "../preloader";
import vdcom from "../../lib/vd";
import { useActivePartnerProvider } from "../../data/active-partner-provider/hooks";

export default function AIConsent() {
  const [loading, setLoading] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);
  const { setActivePartner } = useActivePartnerProvider();
  const handleOnDecline = () => {
    page("/");
  };

  const handleOnAccept = () => {
    setLoading(true);
    vdcom
      .partner()
      .updateAIConsent(true)
      .then((result) => {
        if (result) {
          console.log(result);
          setActivePartner(result);
          setConsentGiven(true);
          page("/chat");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <div className="flex justify-center items-center h-full bg-gray-100 p-4">
      <Card className="w-full max-w-lg shadow-lg rounded-2xl  bg-white">
        <Box className="flex flex-col h-96 p-6">
          <img
            src={logo}
            alt="Logo"
            style={{
              height: 40,
              position: "absolute",
              top: -70,
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
          {loading && (
            <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-90 flex items-center justify-center">
              <Preloader />
            </div>
          )}
          <h2 className="text-2xl font-bold mb-4">AI Service Consent</h2>
          <div className="flex-1 overflow-y-auto mb-4 pr-2">
            <p className="text-gray-600 text-sm">
              By using our AI services, you agree that all data insights and
              suggestions provided by ChatGPT are generated by an external AI
              tool. You remain solely responsible for interpreting and acting on
              this information, including any decisions made or actions taken
              based on AI recommendations. Tower Systems cannot be held liable
              for any direct or indirect consequences arising from your use of
              these AI-generated results. In addition, by proceeding, you
              consent to ChatGPT analysing your data for the purpose of
              delivering its services. For specific advice suited to your
              individual circumstances, please consult a qualified professional.
            </p>
          </div>
          <div className="flex justify-between bg-white border-t p-4 sticky bottom-0">
            <ButtonGroup className={"w-full"}>
              <Button
                disabled={loading}
                className="hover:bg-gray-200"
                fullWidth
                onClick={handleOnAccept}
              >
                <div className="flex items-center justify-center">
                  <span className="text-base font-semibold text-[#4394e5]">
                    Accept
                  </span>
                </div>
              </Button>
              <Button
                disabled={loading}
                fullWidth
                onClick={handleOnDecline}
                className="hover:bg-gray-200"
              >
                <span className="text-base font-semibold text-red-400">
                  Decline
                </span>
              </Button>
            </ButtonGroup>
          </div>
        </Box>
      </Card>
    </div>
  );
}
